import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, Phone } from 'lucide-react';

export const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Accueil', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Réserver', path: '/booking' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-100" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
            <div className="h-11 md:h-12 overflow-hidden flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_nettoyage-rdv/artifacts/sr58gnln_Screenshot_2025-11-19-09-02-07-924_com.miui.gallery.jpg" 
                alt="BA NETTOYAGE" 
                className="h-[220%] w-auto object-cover object-center"
                style={{ marginTop: '-30%', marginBottom: '-30%' }}
              />
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link font-medium transition-colors ${
                  isActive(link.path) ? 'text-sky-500' : 'text-slate-600 hover:text-slate-900'
                }`}
                data-testid={`nav-${link.name.toLowerCase()}`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Phone */}
          <div className="hidden md:flex items-center">
            <a href="tel:0769119183" className="flex items-center gap-2 text-slate-600 hover:text-sky-500 transition-colors">
              <Phone className="w-4 h-4" />
              <span className="font-medium">07 69 11 91 83</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-slate-100 transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-16 left-0 right-0 bg-white border-b border-slate-100 shadow-lg animate-fade-in">
          <div className="px-4 py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-3 rounded-lg font-medium transition-colors ${
                  isActive(link.path) 
                    ? 'bg-sky-50 text-sky-500' 
                    : 'text-slate-600 hover:bg-slate-50'
                }`}
                onClick={() => setMobileMenuOpen(false)}
                data-testid={`mobile-nav-${link.name.toLowerCase()}`}
              >
                {link.name}
              </Link>
            ))}
            <div className="border-t border-slate-100 pt-4 mt-4">
              <a 
                href="tel:0769119183" 
                className="flex items-center gap-2 px-4 py-3 text-slate-600 font-medium"
              >
                <Phone className="w-4 h-4" />
                07 69 11 91 83
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};
